import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/scrollbar/scrollbar.scss";

import { Checkbox, Divider } from "antd";
import React from "react";
import { MoneyFormat, upperCase, useWindowsSize } from "../../libs";
import CardService from "../Card/CardService";
import { Swiper, SwiperSlide } from "swiper/react";
import moment from "moment";
import "moment/locale/id";
import ErrorPage from "../Notification/Error";
import Payment from "./Payment";
import Change from "./Change";
import { Link, useHistory } from "react-router-dom";

function CartPage({ props }) {
  const {
    layanan,
    data,
    onRemove,
    onRemoveAll,
    onSelect,
    onChange,
    onActive,
    onSubmit,
    loading,
    loadChat,
    isVisible,
    isModal,
    showModal,
    onCancel,
    onCash,
    cash,
    cashOk,
    onSubmitCash,
    cashError,
    isError,
    isErrorModal,
    onModal,
    tempData,
    onQty,
    isBank,
  } = props;

  const size = useWindowsSize();
  const history = useHistory();
  const bank = isBank.filter((it) => it.id === cashOk);
  const isEmpty = data.filter((it) => it.active).length === 0;

  return (
    <>
      {/* Metode Pembayaran */}
      <Payment
        props={{
          isVisible,
          loading,
          onSubmitCash,
          cashError,
          onCancel,
          onCash,
          cash,
          isBank,
        }}
      />
      <Change
        props={{
          isModal,
          onCancel,
          tempData,
          onSelect,
          onChange,
          loadChat,
          isErrorModal,
        }}
      />
      <div className="product">
        <div className="container mx-auto py-6 lg:py-10">
          {/* Ini Adalah Breadcrumb */}
          <div name="breadecrumb" className="flex items-center mb-6 lg:mb-8">
            <p className="m-0 text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-gray">
              Katalog
            </p>
            <img
              className="mr-3 lg:mr-5"
              src={process.env.REACT_APP_BASE_URL + "/assets/icon/ic_arrow.svg"}
              alt="icon-arrow"
            />
            <p className="m-0 text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-gray">
              Produk
            </p>
            <img
              className="mr-3 lg:mr-5"
              src={process.env.REACT_APP_BASE_URL + "/assets/icon/ic_arrow.svg"}
              alt="icon-arrow"
            />
            <p className="m-0 text-xs lg:text-sm font-semibold mr-3 lg:mr-5 colors-blue">
              Checkout
            </p>
          </div>

          {data.length ? (
            // Content
            <div className="grid grid-cols-1 lg:grid-cols-3 grid-rows-1 gap-2 lg:gap-10 ">
              {/* Left Content */}
              <div className="lg:col-span-2">
                <div className="product-card p-3 lg:p-10">
                  <p className="header-title-semi colors-blue text-xl font-semibold mb-8">
                    Daftar Pesanan
                  </p>
                  <div
                    name="pilih semua"
                    className="flex justify-between items-center"
                  >
                    <Checkbox
                      onChange={(e) => onActive(e, 1, null, null, null)}
                      checked={!isEmpty}
                    >
                      <p className="header-content ml-2 colors-blue text-base">
                        Pilih semua
                      </p>
                    </Checkbox>
                    <p
                      onClick={onRemoveAll}
                      className="header-content colors-gray cursor-pointer text-base"
                    >
                      Hapus Semua
                    </p>
                  </div>
                  <Divider />
                  {data.map((it, index) => (
                    <>
                      <div key={index} className="my-5 lg:my-8">
                        {/* Harga Section */}
                        <div className="flex">
                          <Checkbox
                            checked={it.active}
                            onChange={(e) =>
                              onActive(e, 2, index, it.id, it.info)
                            }
                          />
                          <div className="w-20 h-20 lg:w-28 lg:h-28 ml-4 mr-4 lg:mr-6  ">
                            <img
                              className="w-20 h-20 lg:w-28 lg:h-28 object-cover rounded-2xl "
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "/assets/image/img_empty.png"; // some replacement image
                              }}
                              src={
                                typeof it.image !== "string"
                                  ? process.env.REACT_APP_BACKEND_URL +
                                    "/storage/" +
                                    it.image[0]
                                  : process.env.REACT_APP_BACKEND_URL +
                                    "/storage/" +
                                    it.image
                              }
                              alt="img-media"
                            />
                          </div>
                          <div className="w-3/5 lg:w-2/6">
                            <p className="header-content colors-gray text-xs lg:text-sm">
                              {it.info !== 3
                                ? "Layanan Kesehatan"
                                : "Media Reagensia"}
                            </p>
                            <Link
                              to={
                                it.info === 1
                                  ? `/product/satuan/${it.id}`
                                  : it.info === 2
                                  ? `/product/paket/${it.id}`
                                  : `/media/${it.id}`
                              }
                            >
                              <p className="header-title-semi colors-blue mt-2 text-md lg:text-lg font-semibold ">
                                {upperCase(
                                  it?.name ??
                                    "PCR Swab Test (Drive Thru) Hasil 1 Hari Kerja"
                                )}
                              </p>
                            </Link>
                            <p className="header-content colors-orange text-base lg:text-lg mt-2 font-semibold ">
                              {it.price
                                ? "Rp. " + MoneyFormat(Number(it.price))
                                : "Rp. 100.000"}
                            </p>
                          </div>
                        </div>

                        {/* Input Change Section */}
                        <div className="lg:flex mt-5">
                          <div className="mr-8 lg:mr-0"></div>
                          {size.width > 640 && (
                            <div className="w-24 h-24 lg:w-28 lg:h-28 ml-4 mr-4 lg:mr-10  "></div>
                          )}
                          <div className="w-full lg:w-2/6 mr-5">
                            {it.info !== 3 && (
                              <div className="flex justify-between">
                                <p className="header-content colors-gray text-sm">
                                  Tanggal Pemeriksaan
                                </p>
                                <p
                                  onClick={() => {
                                    showModal(2);
                                    onModal(
                                      index,
                                      it.id,
                                      "tgl_pemeriksaan",
                                      it.tgl_pemeriksaan
                                    );
                                  }}
                                  className="header-content colors-blue text-sm font-semibold cursor-pointer"
                                >
                                  Ubah
                                </p>
                              </div>
                            )}
                            {it.info !== 3 && (
                              <div className="flex mt-1">
                                <img
                                  className="mr-3"
                                  src={
                                    process.env.REACT_APP_BASE_URL +
                                    "/assets/icon/ic_calender_gray.svg"
                                  }
                                  alt="icon-calender"
                                />
                                <p className="header-content text-base colors-blue font-semibold">
                                  {it.tgl_pemeriksaan
                                    ? moment(it.tgl_pemeriksaan).format(
                                        "dddd , DD MMMM YYYY"
                                      )
                                    : "Pilih Tanggal"}
                                </p>
                              </div>
                            )}
                            <div className="flex justify-between mt-4">
                              <p className="header-content colors-gray text-sm">
                                {it.info !== 3
                                  ? "Waktu Pemeriksaan"
                                  : "Catatan"}
                              </p>
                              <p
                                onClick={() => {
                                  showModal(2);
                                  onModal(
                                    index,
                                    it.id,
                                    it.info !== 3 ? "jam_pemeriksaan" : "note",
                                    it.info !== 3 ? it.jam_pemeriksaan : it.note
                                  );
                                }}
                                className="header-content colors-blue text-sm font-semibold cursor-pointer"
                              >
                                Ubah
                              </p>
                            </div>
                            {it.info !== 3 ? (
                              <div className="flex mt-1">
                                <img
                                  className="mr-3"
                                  src={
                                    process.env.REACT_APP_BASE_URL +
                                    "/assets/icon/ic_time.svg"
                                  }
                                  alt="icon-time"
                                />
                                <p className="header-content text-base colors-blue font-semibold">
                                  {it.jam_pemeriksaan
                                    ? it.jam_pemeriksaan + " WIB"
                                    : "Pilih Waktu"}
                                </p>
                              </div>
                            ) : (
                              <p className="header-content text-sm colors-gray">
                                ini adalah catatan, {it.note}
                              </p>
                            )}
                          </div>

                          {/* Trash Section */}
                          {/* Handle Mobile Section */}
                          <div className="mt-4 lg:mt-0  flex items-center justify-between lg:justify-end lg:relative w-full lg:w-1/3">
                            {size.width <= 640 && (
                              <div>
                                <div className="text-red-500 text-xs lg:mb-5">
                                  {it.qty >= it.stock && `Max. ${it.stock} pcs`}
                                </div>
                                <p className="header-content colors-gray text-base ">
                                  Jumlah Pembelian
                                </p>
                              </div>
                            )}
                            <div className="header-content text-red-500 text-xs mb-5">
                              {it.qty >= it.stock &&
                                size.width > 640 &&
                                `Max. pembelian ${it.stock} pcs`}
                            </div>
                            <div className="lg:absolute lg:bottom-0">
                              {size.width > 640 && (
                                <p className="header-content colors-gray text-base text-right">
                                  Jumlah Pembelian
                                </p>
                              )}

                              {/* QTY Section */}
                              <div
                                name="qty-section"
                                className="flex items-center lg:mt-2"
                              >
                                <img
                                  onClick={() => onRemove(index)}
                                  className="cursor-pointer mr-8 lg:mr-14"
                                  src={
                                    process.env.REACT_APP_BASE_URL +
                                    "/assets/icon/ic_trash.svg"
                                  }
                                  alt="icon-trash"
                                />

                                {it.info === 3 && (
                                  <img
                                    onClick={() =>
                                      it.qty <= 1
                                        ? null
                                        : onQty("min", index, it.id)
                                    }
                                    className="cursor-pointer"
                                    src={
                                      process.env.REACT_APP_BASE_URL +
                                      `/assets/icon/${
                                        it.qty <= 1
                                          ? "ic_min.svg"
                                          : "ic_min_blue.svg"
                                      }`
                                    }
                                    alt="icon-minus"
                                  />
                                )}
                                <p className="header-content colors-blue font-semibold m-0 text-xl mx-3">
                                  {it.qty}
                                </p>
                                {it.info === 3 && (
                                  <img
                                    onClick={() =>
                                      it.qty >= it.stock
                                        ? null
                                        : onQty("plus", index, it.id)
                                    }
                                    className="cursor-pointer"
                                    src={
                                      process.env.REACT_APP_BASE_URL +
                                      `/assets/icon/${
                                        it.qty >= it.stock
                                          ? "ic_plus_gray.svg"
                                          : "ic_plus.svg"
                                      }`
                                    }
                                    alt="icon-plus"
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {size.width <= 640 && <Divider />}
                    </>
                  ))}
                </div>
              </div>

              {/* Right Content */}
              {size.width > 640 && (
                <div className="product-card h-auto p-10">
                  <div name="header-section" className="w-full">
                    <p className="header-content-semi text-center colors-blue font-semibold text-2xl">
                      Ringkasan Pembelanjaan
                    </p>
                    <div className="mt-6">
                      {data
                        .filter((it) => it.active)
                        .map((it, index) => (
                          <div
                            key={index}
                            className="flex items-center justify-between mt-2"
                          >
                            <p className="colors-gray text-base">
                              {upperCase(it.name)}
                            </p>
                            <p className="colors-gray text-base font-semibold">
                              {"Rp. " + MoneyFormat(Number(it.price))}
                            </p>
                          </div>
                        ))}
                      {isEmpty && (
                        <p className="header-content colors-gray text-center text-base">
                          Silahkan untuk memilih pesanan kamu terlebih dahulu
                          sebelum membayar
                        </p>
                      )}
                    </div>
                    <Divider />
                    <div className="flex items-center justify-between mt-2">
                      <p className="header-content colors-blue text-base font-semibold">
                        Total Harga
                      </p>
                      <p className="colors-orange text-lg font-semibold">
                        {"Rp. " +
                          MoneyFormat(
                            data
                              .filter((it) => it.active)
                              .reduce((a, b) => +a + +b.price, 0)
                          )}
                      </p>
                    </div>

                    <div className="mt-6 cursor-pointer">
                      <p className="header-content colors-blue text-base font-semibold">
                        Metode Pembayaran
                      </p>
                      {cashOk ? (
                        <div
                          onClick={() => showModal(1)}
                          className="flex mt-3 justify-between items-center cursor-pointer"
                        >
                          <div className="flex item-center">
                            <img
                              src={bank[0].logo}
                              alt="icon-bank"
                              className="w-5 h-auto"
                            />
                            <p className="header-content text-green-700 ml-2 font-semibold">
                              {bank[0].name}
                            </p>
                          </div>
                          <p className="header-content colors-blue font-semibold">
                            Pilih Pembayaran Lain
                          </p>
                        </div>
                      ) : (
                        <div
                          onClick={() => showModal(1)}
                          className="flex justify-between items-center cursor-pointer"
                        >
                          <p className="header-content colors-gray text-base  my-3">
                            Pilih Metode Pembayaran
                          </p>
                          <img
                            src={
                              process.env.REACT_APP_BASE_URL +
                              "/assets/icon/ic_arrow.svg"
                            }
                            alt="icon-arrow"
                          />
                        </div>
                      )}
                    </div>

                    {isError.length > 0 && (
                      <ErrorPage key={1} props={{ idx: 1, message: isError }} />
                    )}

                    <button
                      disabled={loading}
                      onClick={onSubmit}
                      className={`${
                        loading ? "btn-loading" : "btn-blue"
                      } w-full p-3 mt-8 focus:outline-none`}
                    >
                      <p className="text-white font-semibold lg:text-lg">
                        {loading ? "Loading" : "Bayar Sekarang"}
                      </p>
                    </button>
                    <button
                      disabled={loading}
                      onClick={() => history.push("/")}
                      className={`${
                        loading ? "btn-loading" : "btn-white"
                      } w-full p-3  focus:outline-none mt-4`}
                    >
                      <p className="colors-gray lg:text-lg ">
                        Belanja Produk Lain
                      </p>
                    </button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="product-card p-3 lg:p-10">
              <p className="header-title-semi  colors-blue text-xl font-semibold mb-12 lg:mb-8">
                Daftar Pesanan
              </p>
              <div className="w-full flex flex-row content-center justify-center">
                <div className="lg:w-1/3">
                  <div className="w-full flex justify-center">
                    <img
                      className="mb-8"
                      src={
                        process.env.REACT_APP_BASE_URL +
                        "/assets/icon/ic_empty_cart.svg"
                      }
                      alt="icon-empty-cart"
                    />
                  </div>
                  <div className="w-full">
                    <p className="header-content text-center colors-blue text-xl font-semibold mb-4">
                      Keranjang Pembelanjaan Kosong
                    </p>
                    <p className="header-content text-center colors-gray text-base mb-8">
                      Keranjang belanja anda masih kosong, silahkan menambahkan
                      pembelanjaan anda
                    </p>
                  </div>
                  <Link to={"/"}>
                    <div className="flex justify-center">
                      <button className="btn-blue w-full lg:w-4/5 p-3 focus:outline-none mb-8">
                        <p className="text-white lg:text-lg">Mulai Belanja</p>
                      </button>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          )}

          {/* Footer Rekomendasi Section */}
          <div>
            <p className="header-title-bold colors-blue mt-8 text-xl lg:text-2xl font-bold">
              Rekomendasi untuk anda
            </p>
            <div className="w-full mt-5">
              <Swiper spaceBetween={30} slidesPerView={2}>
                {layanan.map((it, index) => (
                  <SwiperSlide key={index}>
                    <Link key={index} to={`/product/satuan/${it.id}`}>
                      <CardService props={{ layanan: it }} />
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>

        {/* Ini Footer Buat Checkout Versi Mobile */}
        {size.width <= 640 && data.length > 0 && (
          <div
            className="product-checkout bg-white px-5 h-auto py-4"
            style={{ zIndex: 1 }}
          >
            <div className="mb-4">
              {/* <p className="colors-blue mb-4 text-lg font-semibold">
                Metode Pembayaran
              </p> */}
              {cashOk ? (
                <div
                  onClick={() => showModal(1)}
                  className="flex mt-3 justify-between items-center cursor-pointer"
                >
                  <div className="flex item-center">
                    <img src={bank[0].logo} alt="icon-bank" />

                    <p className="colors-blue ml-3 font-semibold">
                      {bank[0].name}
                    </p>
                  </div>
                  <p className="colors-blue font-semibold">Pilih Bank Lain</p>
                </div>
              ) : (
                <div
                  onClick={() => showModal(1)}
                  className="flex justify-between items-center cursor-pointer"
                >
                  <p className="colors-gray text-sm cursor-pointer">
                    Pilih Metode Pembayaran
                  </p>
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "/assets/icon/ic_arrow.svg"
                    }
                    alt="icon-arrow"
                  />
                </div>
              )}
              {isError.length > 0 && (
                <ErrorPage key={1} props={{ idx: 1, message: isError }} />
              )}
            </div>
            <div className="flex justify-between items-center content-center h-full">
              <div>
                <p className="colors-blue">Total Harga</p>
                <p className="colors-orange text-lg font-semibold">
                  {"Rp. " +
                    MoneyFormat(
                      data
                        .filter((it) => it.active)
                        .reduce((a, b) => +a + +b.price, 0)
                    )}
                </p>
              </div>
              <div className="w-2/4">
                <button
                  disabled={loading}
                  className={`${
                    loading ? "btn-loading" : "btn-blue"
                  } w-full p-3 focus:outline-none`}
                  onClick={onSubmit}
                >
                  <p className="text-white font-semibold lg:text-lg">
                    {loading ? "Loading" : "Bayar Sekarang"}
                  </p>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default CartPage;
